import '../../../3P/mootools-custom/MooTools-Core-1.6.0.js';
import '../../../3P/mootools-custom/MooTools-More-1.6.0.js';
import '../../../3P/then-promise/promise.js';
import './promise.extras.js';
import '../../../3P/gsap/TweenMax.min.js';
import '../../../3P/gsap/ScrollToPlugin.min.js';
import './disable_spellcheck_for_tests.js';
import './utils.js';
import './api_2_0.js';
import './form_manager.js';
import './modal.js';
import './frame_modules.js';
import './csrf.js';
import './realtime_date.js';
import './filter_manager.js';
import '../../../3P/js-strftime/strftime.js';
import './Autocompleter/Autocompleter.js';
import './Autocompleter/Autocompleter.Request.js';
import './Autocompleter/Autocompleter.Local.js';
import './Autocompleter/Observer.js';
import './button-dropdown.js';
import './loading_indicator.js';
import './fallbacks.js';
import './lazy_load_bg.js';
